import * as React from 'react';
import {
    SelectInput,
} from 'react-admin';
import PropTypes from 'prop-types';
// import { useRecordContext } from 'react-admin';

const choices = [
    { id: 'azure_sql', name: 'Azure SQL' },
    { id: 'postgres', name: 'Postgres' },
    { id: 'mysql', name: 'MySQL' },
];

const DatabaseItemTypesInput = (props) => {
    // const { source } = props;
    // const record = useRecordContext(props);

    return (
        <SelectInput choices={choices} optionValue="id" {...props} />
    );
};

DatabaseItemTypesInput.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default DatabaseItemTypesInput;
